import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { assert } from '@ember/debug';
import { concat } from '@ember/helper';
import { t } from 'ember-intl';
import { HdsAlert } from '@hashicorp/design-system-components/components';
import { PEERING_ROUTE_NAMES, TGW_ROUTE_NAMES } from '../../../utils/network-routes.js';
/**
 *
 * `NetworksCardsConnectionStatus` description here.
 *
 *
 * ```
 * <Networks::Cards::ConnectionStatus
 *   @state={{state}}
 *   @onDismiss={{function}}
 * />
 * ```
 *
 * @class NetworksCardsConnectionStatus
 *
 */ export default class NetworksCardsConnectionStatus extends Component {
    /**
   * Peering/TGW connection state string. supported [ ACTIVE, FAILED, EXPIRED]
   * @argument state
   * @type {string}
   */ /**
   * callback function to be call on dismissal icon click
   * @argument onDismiss
   * @type {Function}
   */ buildOption(state1) {
        let failed1 = {
            icon: 'alert-diamond',
            type: 'connection',
            color: 'critical',
            routes: [
                {
                    route: PEERING_ROUTE_NAMES.create,
                    i18n: 'components.networks.common.connection.peering-connection'
                },
                {
                    route: TGW_ROUTE_NAMES.create,
                    i18n: 'components.networks.common.connection.transit-gateway-attachment'
                }
            ]
        };
        switch(state1){
            case 'ACTIVE':
                return {
                    icon: 'check-circle',
                    type: 'cluster',
                    color: 'success',
                    status: state1 ? state1.toLowerCase() : '',
                    routes: [
                        {
                            route: 'vault.clusters.list',
                            i18n: 'components.networks.common.product.vault'
                        },
                        {
                            route: 'consul.clusters.overview',
                            i18n: 'components.networks.common.product.consul'
                        }
                    ]
                };
            case 'FAILED':
                return {
                    ...failed1,
                    status: state1.toLowerCase()
                };
            case 'EXPIRED':
                return {
                    ...failed1,
                    status: state1.toLowerCase()
                };
            default:
                assert('Unsupported state string was passed.', state1 === undefined);
        }
    }
    get option() {
        return this.buildOption(this.args.state);
    }
    get isSuccess() {
        return this.args.state === 'ACTIVE';
    }
    static{
        template(`
    <div
      class="networks-cards-connection-status"
      data-test-networks-cards-connection-status
      ...attributes
    >
      <HdsAlert
        class="networks-cards-connection-status"
        @type="inline"
        @icon={{this.option.icon}}
        @color={{this.option.color}}
        @onDismiss={{@onDismiss}}
        as |A|
      >
        <A.Title class="hds-typography-display-100 hds-font-weight-medium">
          {{t
            (concat
              "components.networks.cards.status.title." this.option.status
            )
            status=this.option.status
          }}
        </A.Title>
        <A.Description class="hds-typography-body-100 hds-foreground-faint">
          {{t
            (concat
              "components.networks.cards.status.description." this.option.status
            )
            htmlSafe=true
          }}
        </A.Description>
        {{#if this.isSuccess}}
          {{#each this.option.routes as |link|}}
            <A.LinkStandalone
              @text={{t
                "components.networks.cards.status.go-to-clusters"
                service=(t link.i18n)
              }}
              @route={{link.route}}
              @isRouteExternal={{true}}
              @icon="arrow-right"
              @iconPosition="trailing"
            />
          {{/each}}
        {{else}}
          {{#each this.option.routes as |link|}}
            <A.LinkStandalone
              @text={{t
                "components.networks.cards.status.cta"
                connection=(t link.i18n)
              }}
              @route={{link.route}}
              @icon="arrow-right"
              @iconPosition="trailing"
            />
          {{/each}}
        {{/if}}
      </HdsAlert>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
//# sourceMappingURL=data:application/json;base64,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_IHN0YXRlLnRvTG93ZXJDYXNlKCkgOiAnJyxcbiAgICAgICAgICByb3V0ZXM6IFtcbiAgICAgICAgICAgIHtcbiAgICAgICAgICAgICAgcm91dGU6ICd2YXVsdC5jbHVzdGVycy5saXN0JyxcbiAgICAgICAgICAgICAgaTE4bjogJ2NvbXBvbmVudHMubmV0d29ya3MuY29tbW9uLnByb2R1Y3QudmF1bHQnLFxuICAgICAgICAgICAgfSxcbiAgICAgICAgICAgIHtcbiAgICAgICAgICAgICAgcm91dGU6ICdjb25zdWwuY2x1c3RlcnMub3ZlcnZpZXcnLFxuICAgICAgICAgICAgICBpMThuOiAnY29tcG9uZW50cy5uZXR3b3Jrcy5jb21tb24ucHJvZHVjdC5jb25zdWwnLFxuICAgICAgICAgICAgfSxcbiAgICAgICAgICBdLFxuICAgICAgICB9O1xuICAgICAgY2FzZSAnRkFJTEVEJzpcbiAgICAgICAgcmV0dXJuIHtcbiAgICAgICAgICAuLi5mYWlsZWQsXG4gICAgICAgICAgc3RhdHVzOiBzdGF0ZS50b0xvd2VyQ2FzZSgpLFxuICAgICAgICB9O1xuICAgICAgY2FzZSAnRVhQSVJFRCc6XG4gICAgICAgIHJldHVybiB7XG4gICAgICAgICAgLi4uZmFpbGVkLFxuICAgICAgICAgIHN0YXR1czogc3RhdGUudG9Mb3dlckNhc2UoKSxcbiAgICAgICAgfTtcbiAgICAgIGRlZmF1bHQ6XG4gICAgICAgIGFzc2VydCgnVW5zdXBwb3J0ZWQgc3RhdGUgc3RyaW5nIHdhcyBwYXNzZWQuJywgc3RhdGUgPT09IHVuZGVmaW5lZCk7XG4gICAgfVxuICB9XG5cbiAgZ2V0IG9wdGlvbigpIHtcbiAgICByZXR1cm4gdGhpcy5idWlsZE9wdGlvbih0aGlzLmFyZ3Muc3RhdGUpO1xuICB9XG5cbiAgZ2V0IGlzU3VjY2VzcygpIHtcbiAgICByZXR1cm4gdGhpcy5hcmdzLnN0YXRlID09PSAnQUNUSVZFJztcbiAgfVxuXG4gIDx0ZW1wbGF0ZT5cbiAgICA8ZGl2XG4gICAgICBjbGFzcz1cIm5ldHdvcmtzLWNhcmRzLWNvbm5lY3Rpb24tc3RhdHVzXCJcbiAgICAgIGRhdGEtdGVzdC1uZXR3b3Jrcy1jYXJkcy1jb25uZWN0aW9uLXN0YXR1c1xuICAgICAgLi4uYXR0cmlidXRlc1xuICAgID5cbiAgICAgIDxIZHNBbGVydFxuICAgICAgICBjbGFzcz1cIm5ldHdvcmtzLWNhcmRzLWNvbm5lY3Rpb24tc3RhdHVzXCJcbiAgICAgICAgQHR5cGU9XCJpbmxpbmVcIlxuICAgICAgICBAaWNvbj17e3RoaXMub3B0aW9uLmljb259fVxuICAgICAgICBAY29sb3I9e3t0aGlzLm9wdGlvbi5jb2xvcn19XG4gICAgICAgIEBvbkRpc21pc3M9e3tAb25EaXNtaXNzfX1cbiAgICAgICAgYXMgfEF8XG4gICAgICA-XG4gICAgICAgIDxBLlRpdGxlIGNsYXNzPVwiaGRzLXR5cG9ncmFwaHktZGlzcGxheS0xMDAgaGRzLWZvbnQtd2VpZ2h0LW1lZGl1bVwiPlxuICAgICAgICAgIHt7dFxuICAgICAgICAgICAgKGNvbmNhdFxuICAgICAgICAgICAgICBcImNvbXBvbmVudHMubmV0d29ya3MuY2FyZHMuc3RhdHVzLnRpdGxlLlwiIHRoaXMub3B0aW9uLnN0YXR1c1xuICAgICAgICAgICAgKVxuICAgICAgICAgICAgc3RhdHVzPXRoaXMub3B0aW9uLnN0YXR1c1xuICAgICAgICAgIH19XG4gICAgICAgIDwvQS5UaXRsZT5cbiAgICAgICAgPEEuRGVzY3JpcHRpb24gY2xhc3M9XCJoZHMtdHlwb2dyYXBoeS1ib2R5LTEwMCBoZHMtZm9yZWdyb3VuZC1mYWludFwiPlxuICAgICAgICAgIHt7dFxuICAgICAgICAgICAgKGNvbmNhdFxuICAgICAgICAgICAgICBcImNvbXBvbmVudHMubmV0d29ya3MuY2FyZHMuc3RhdHVzLmRlc2NyaXB0aW9uLlwiIHRoaXMub3B0aW9uLnN0YXR1c1xuICAgICAgICAgICAgKVxuICAgICAgICAgICAgaHRtbFNhZmU9dHJ1ZVxuICAgICAgICAgIH19XG4gICAgICAgIDwvQS5EZXNjcmlwdGlvbj5cbiAgICAgICAge3sjaWYgdGhpcy5pc1N1Y2Nlc3N9fVxuICAgICAgICAgIHt7I2VhY2ggdGhpcy5vcHRpb24ucm91dGVzIGFzIHxsaW5rfH19XG4gICAgICAgICAgICA8QS5MaW5rU3RhbmRhbG9uZVxuICAgICAgICAgICAgICBAdGV4dD17e3RcbiAgICAgICAgICAgICAgICBcImNvbXBvbmVudHMubmV0d29ya3MuY2FyZHMuc3RhdHVzLmdvLXRvLWNsdXN0ZXJzXCJcbiAgICAgICAgICAgICAgICBzZXJ2aWNlPSh0IGxpbmsuaTE4bilcbiAgICAgICAgICAgICAgfX1cbiAgICAgICAgICAgICAgQHJvdXRlPXt7bGluay5yb3V0ZX19XG4gICAgICAgICAgICAgIEBpc1JvdXRlRXh0ZXJuYWw9e3t0cnVlfX1cbiAgICAgICAgICAgICAgQGljb249XCJhcnJvdy1yaWdodFwiXG4gICAgICAgICAgICAgIEBpY29uUG9zaXRpb249XCJ0cmFpbGluZ1wiXG4gICAgICAgICAgICAvPlxuICAgICAgICAgIHt7L2VhY2h9fVxuICAgICAgICB7e2Vsc2V9fVxuICAgICAgICAgIHt7I2VhY2ggdGhpcy5vcHRpb24ucm91dGVzIGFzIHxsaW5rfH19XG4gICAgICAgICAgICA8QS5MaW5rU3RhbmRhbG9uZVxuICAgICAgICAgICAgICBAdGV4dD17e3RcbiAgICAgICAgICAgICAgICBcImNvbXBvbmVudHMubmV0d29ya3MuY2FyZHMuc3RhdHVzLmN0YVwiXG4gICAgICAgICAgICAgICAgY29ubmVjdGlvbj0odCBsaW5rLmkxOG4pXG4gICAgICAgICAgICAgIH19XG4gICAgICAgICAgICAgIEByb3V0ZT17e2xpbmsucm91dGV9fVxuICAgICAgICAgICAgICBAaWNvbj1cImFycm93LXJpZ2h0XCJcbiAgICAgICAgICAgICAgQGljb25Qb3NpdGlvbj1cInRyYWlsaW5nXCJcbiAgICAgICAgICAgIC8-XG4gICAgICAgICAge3svZWFjaH19XG4gICAgICAgIHt7L2lmfX1cbiAgICAgIDwvSGRzQWxlcnQ-XG4gICAgPC9kaXY-XG4gIDwvdGVtcGxhdGU-XG59XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sZUFBZSxxQkFBcUI7QUFDM0MsU0FBUyxNQUFNLFFBQVEsZUFBZTtBQUN0QyxTQUFTLE1BQU0sUUFBUSxnQkFBZ0I7QUFDdkMsU0FBUyxDQUFDLFFBQVEsYUFBYTtBQUMvQixTQUFTLFFBQVEsUUFBUSxpREFBaUQ7QUFFMUUsU0FDRSxtQkFBbUIsRUFDbkIsZUFBZSxRQUNWLG1DQUFtQztBQUUxQzs7Ozs7Ozs7Ozs7Ozs7Q0FjQyxHQUVELGVBQWUsTUFBTSxzQ0FBc0M7SUFDekQ7Ozs7R0FJQyxHQUNEOzs7O0dBSUMsR0FFRCxZQUFZLE1BQUssRUFBRTtRQUNqQixJQUFJLFVBQVM7WUFDWCxNQUFNO1lBQ04sTUFBTTtZQUNOLE9BQU87WUFDUCxRQUFRO2dCQUNOO29CQUNFLE9BQU8sb0JBQW9CLE1BQU07b0JBQ2pDLE1BQU07Z0JBQ1I7Z0JBQ0E7b0JBQ0UsT0FBTyxnQkFBZ0IsTUFBTTtvQkFDN0IsTUFBTTtnQkFDUjthQUNEO1FBQ0g7UUFDQSxPQUFRO1lBQ04sS0FBSztnQkFDSCxPQUFPO29CQUNMLE1BQU07b0JBQ04sTUFBTTtvQkFDTixPQUFPO29CQUNQLFFBQVEsU0FBUSxPQUFNLFdBQVcsS0FBSztvQkFDdEMsUUFBUTt3QkFDTjs0QkFDRSxPQUFPOzRCQUNQLE1BQU07d0JBQ1I7d0JBQ0E7NEJBQ0UsT0FBTzs0QkFDUCxNQUFNO3dCQUNSO3FCQUNEO2dCQUNIO1lBQ0YsS0FBSztnQkFDSCxPQUFPO29CQUNMLEdBQUcsT0FBTTtvQkFDVCxRQUFRLE9BQU0sV0FBVztnQkFDM0I7WUFDRixLQUFLO2dCQUNILE9BQU87b0JBQ0wsR0FBRyxPQUFNO29CQUNULFFBQVEsT0FBTSxXQUFXO2dCQUMzQjtZQUNGO2dCQUNFLE9BQU8sd0NBQXdDLFdBQVU7UUFDN0Q7SUFDRjtJQUVBLElBQUksU0FBUztRQUNYLE9BQU8sSUFBSSxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUs7SUFDekM7SUFFQSxJQUFJLFlBQVk7UUFDZCxPQUFPLElBQUksQ0FBQyxJQUFJLENBQUMsS0FBSyxLQUFLO0lBQzdCO0lBRUEsTUFBQTtRQUFBLFNBQVUsQ0FBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztFQTBEVixDQUFBLEVBQUE7WUFBQSxXQUFBLElBQVc7WUFBWDtnQkFBQSxPQUFBLEtBQUEsU0FBQSxDQUFBLEVBQVc7WUFBRDtRQUFBO0lBQUEsQ0ExREE7QUEyRFoifQ